import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Meta from 'vue-meta'




Vue.use(Router)
Vue.use(Meta)

export default new Router({
    /*    mode: 'history',
        //   base: process.env.BASE_URL,
        base: '/',
         */
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('./views/Login.vue')
        },
        {
            path: '/print',
            name: 'print',
            component: () =>
                import ('./views/PrintItems.vue')
        },
        {
            path: '/web',
            name: 'web',
            component: () =>
                import ('./views/WebItems.vue')
        },
        {
            path: "/editor",
            name: 'editor',
            component: () =>
                import ('./views/Editor.vue')
        },
        {
            path: "/editor/:nameItem",
            name: 'editoritems',
            component: () =>
                import ('./views/Editor.vue')
        },
        // Default route (404 page). MUST BE THE LAST
        {
            path: '*',
            name: '404page',
            component: () =>
                import ('./views/404page.vue')
        },
        /*         {
                    path: './*',
                    name: '404page',
                    component: () =>
                        import ('./views/404page.vue')
                }, */
    ]
});